import styled from "styled-components";
import { IInitFields, setField, useFieldError, useFieldValue} from "..";
import { capitalize } from "../../../common/helpers";
import styles from "../../../common/styles";
import { DP, DPInput } from "../../../common/types";
import UInput from "../../../UI/UInput";

interface Props extends DPInput {
  fieldName: keyof IInitFields;
}

const Input = (props: Props) => {
  const value = useFieldValue(props.fieldName);

  return (
    <Wrapper>
      <UInput.InputEl
        placeholder={capitalize(props.fieldName)}
        value={value}
				disabled={props.disabled}
        onChange={(e) => {
          setField(props.fieldName, e.target.value);
        }}
      />
			<ErrorMessage {...props} />
    </Wrapper>
  );
};

const ErrorMessage = (props: {fieldName: keyof IInitFields}) => {
	const error = useFieldError(props.fieldName)

	if (!error) return null;
	return <UInput.ErrorMessage>{error}</UInput.ErrorMessage>
}

const Wrapper = styled(UInput.Wrapper)(() => [styles.border]);

export default Input;
